<div class="row justify-content-md-left">
  <div class="col-xl-8">
    <mat-card>
      <mat-card>
        <b>Lista de Serviços:</b>
      </mat-card>
      <mat-accordion>

        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
          *ngFor=" let grupo of perfil.grupos ">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ grupo.descGrupo }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div *ngFor=" let itemServ of grupo.servicos ">
            <ul>
              <span class="servico">
                <li>{{itemServ.descServico}}</li>
              </span>
            </ul>
          </div>
        </mat-expansion-panel>

      </mat-accordion>
    </mat-card>
  </div>
</div>